import type { LoadableType } from '@confluence/loadable';
import { LoadablePaint } from '@confluence/loadable';
import type { CompanyHomeBuilderUpsellProps } from '../src/CompanyHub/CompanyHomeBuilderUpsell.tsx';

export const CompanyHomeBuilderUpsellPage: LoadableType<CompanyHomeBuilderUpsellProps> =
	LoadablePaint({
		loader: async () =>
			(
				await import(
					/* webpackChunkName: "loadable-CompanyHomeBuilderUpsellPage" */ '../src/CompanyHub/CompanyHomeBuilderUpsellPage.tsx'
				)
			).CompanyHomeBuilderUpsellPage,
	});
